import { ButtonPrimary, ErrorFeedbackScreen } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { IErrorGlobal } from '../../utils/store/model/store.model';
import './index.scss';
import { TrackingEvents } from '../../utils/dataTransformation/tracking';
import { isWebviewIOS } from '../../utils/navigation/controlDevices';

export const ErrorGeneric: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { trackingScreenView } = new TrackingEvents();
    const { data, pathname, customRedirection }: IErrorGlobal = state;

    useEffect(() => {
        if (!isWebviewIOS) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='error-generic-error'>
            <ErrorFeedbackScreen
                title={data?.title!}
                description={data?.localizedDescription!}
                primaryButton={
                    <ButtonPrimary
                        onPress={() => {
                            if (customRedirection) {
                                navigate(pathname!, { state });
                            } else {
                                navigate(-1);
                            }
                        }}
                    >
                        {t('refresh')}
                    </ButtonPrimary>
                }
                errorReference={data?.id !== null ? `${t('codeError')} ${data?.id}` : ''}
            />
        </div>
    );
};

export default ErrorGeneric;
